export const state = {
  contacts: {},
  revisionContacts: {}
}
